"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=chatProps.js.map